export default __webpack_public_path__ + "static/media/badge-rank-new.f4a0e4db.svg";